export default [
  {
    path: '/monitoring-check-balance-transaction',
    name: 'monitoring-check-balance-transaction',
    component: () => import('@/views/pages/komcards/overview/List.vue'),
    meta: {
      resource: 'OverviewMonitoring',
      action: 'manage',
    },
  },
  {
    path: '/monitoring-check-balance-transaction/missing-transactions/:id',
    name: 'monitoring-check-balance-transaction',
    component: () => import('@/views/pages/komcards/overview/ListMissingTrx.vue'),
    meta: {
      resource: 'OverviewMonitoring',
      action: 'manage',
    },
  },
  {
    path: '/monitoring-check-top-up-idle',
    name: 'monitoring-check-top-up-idle',
    component: () => import('@/views/pages/komcards/check-topup-idle/List.vue'),
    meta: {
      resource: 'OverviewMonitoring',
      action: 'manage',
    },
  },
]
